import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, unref as _unref, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/Spin.svg'
import _imports_1 from '@/assets/img/alerte-active.png'
import _imports_2 from '@/assets/icons/teleconsultation-active.png'


const _withScopeId = n => (_pushScopeId("data-v-e52f2814"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container default" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = {
  key: 0,
  class: "position-absolute top-50 start-50"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "btn-spin"
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "card shadow border-0 px-2 px-md-5 py-4" }
const _hoisted_7 = { class: "container-fluid border-bottom-dashed py-2" }
const _hoisted_8 = {
  key: 0,
  class: "fwb"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  class: "img-alert"
}, null, -1))
const _hoisted_10 = {
  key: 1,
  class: "d-flex gap-1 align-items-center"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-link mx-1" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "lien de l'appel", -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-video-camera" }, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  key: 0,
  class: "info-alert py-3 mb-3"
}
const _hoisted_17 = { class: "p-0 m-0 list-none d-md-flex justify-content-between px-4 align-items-center" }
const _hoisted_18 = { class: "m-0 mb-3 mb-md-0" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-1 default fwb" }, "Alerte par:", -1))
const _hoisted_20 = { class: "mb-1" }
const _hoisted_21 = { class: "m-0 mb-3 mb-md-0" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-1 default fwb" }, "Date et heure:", -1))
const _hoisted_23 = { class: "mb-1" }
const _hoisted_24 = { class: "m-0 mb-3 mb-md-0" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-1 default fwb" }, "Status:", -1))
const _hoisted_26 = { class: "m-0 default" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-file mx-1" }, null, -1))
const _hoisted_28 = { class: "container-fluid" }
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "form-group mb-4 col-md" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "typo__label default" }, [
  /*#__PURE__*/_createTextVNode("Type de téléconsultation"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger font-weight-bold" }, "*")
], -1))
const _hoisted_32 = { class: "w-100 d-block d-md-flex align-items-center" }
const _hoisted_33 = {
  key: 0,
  class: "red list-none"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_35 = { class: "d-flex align-items-center mb-3 mt-3" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "consultationIntrouvable",
  class: "mb-0"
}, " Type de Consultation introuvable ? ", -1))
const _hoisted_37 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_38 = { class: "form-group mb-4 col-md" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "typo__label default" }, [
  /*#__PURE__*/_createTextVNode("Etablissement de consultation "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger font-weight-bold" }, "*")
], -1))
const _hoisted_40 = { class: "w-100 d-block d-md-flex align-items-center" }
const _hoisted_41 = {
  key: 0,
  class: "red list-none"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_43 = { class: "container-fluid" }
const _hoisted_44 = { class: "py-2" }
const _hoisted_45 = { class: "pt-2" }
const _hoisted_46 = { class: "px-2 fwb" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "",
  class: "img-alert"
}, null, -1))
const _hoisted_48 = { class: "font-weight-bold px-1" }
const _hoisted_49 = { class: "py-4" }
const _hoisted_50 = { class: "row" }
const _hoisted_51 = { class: "container-fluid w-100 px-md-3" }
const _hoisted_52 = { class: "form-group mb-4" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "typo__label default" }, [
  /*#__PURE__*/_createTextVNode("Motif principal "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger font-weight-bold" }, "*")
], -1))
const _hoisted_54 = { class: "w-100 d-block d-md-flex align-items-center" }
const _hoisted_55 = {
  key: 0,
  class: "red list-none"
}
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_57 = { class: "form-group mb-4" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "typo__label default" }, "Motifs secondaires ", -1))
const _hoisted_59 = { class: "w-100 d-block d-md-flex align-items-center" }
const _hoisted_60 = { class: "form-group mb-4" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "typo__label default" }, [
  /*#__PURE__*/_createTextVNode("Anamnèse "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger font-weight-bold" }, "*")
], -1))
const _hoisted_62 = {
  key: 1,
  class: "red list-none"
}
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_64 = {
  key: 2,
  class: "form-group mt-4"
}
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "typo__label default" }, [
  /*#__PURE__*/_createTextVNode("Description de l'histoire de la maladie "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger font-weight-bold" }, "*")
], -1))
const _hoisted_66 = {
  key: 0,
  class: "red list-none"
}
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_68 = { class: "allergie" }
const _hoisted_69 = {
  key: 0,
  class: "typo__label default mb-1"
}
const _hoisted_70 = {
  key: 1,
  class: "typo__label default mb-1"
}
const _hoisted_71 = { class: "list-none p-0" }
const _hoisted_72 = { class: "d-flex gap-1" }
const _hoisted_73 = {
  key: 0,
  class: "w-100 d-block d-md-flex align-items-center"
}
const _hoisted_74 = { class: "" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-plus" }, null, -1))
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-bookmark" }, null, -1))
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Annuler", -1))
const _hoisted_78 = [
  _hoisted_76,
  _hoisted_77
]
const _hoisted_79 = {
  key: 0,
  class: "allergie"
}
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "typo__label default mb-1" }, "Antécédents du patient", -1))
const _hoisted_81 = { class: "list-none p-0" }
const _hoisted_82 = ["id"]
const _hoisted_83 = ["innerHTML"]
const _hoisted_84 = ["id"]
const _hoisted_85 = ["onClick"]
const _hoisted_86 = ["innerHTML"]
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-plus mx-1" }, null, -1))
const _hoisted_88 = { key: 0 }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "typo__label" }, [
  /*#__PURE__*/_createTextVNode("Type d'antécédent"),
  /*#__PURE__*/_createElementVNode("span", { class: "red" }, "*")
], -1))
const _hoisted_90 = {
  slot: "singleLabel",
  "slot-scope": "{ option }"
}
const _hoisted_91 = {
  key: 0,
  class: "red list-none"
}
const _hoisted_92 = { class: "mt-3" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "typo__label" }, [
  /*#__PURE__*/_createTextVNode("Date début"),
  /*#__PURE__*/_createElementVNode("span", { class: "red" }, "*")
], -1))
const _hoisted_94 = {
  key: 0,
  class: "red list-none"
}
const _hoisted_95 = { class: "mt-3" }
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "typo__label" }, [
  /*#__PURE__*/_createTextVNode("Description"),
  /*#__PURE__*/_createElementVNode("span", { class: "red" }, "*")
], -1))
const _hoisted_97 = { class: "container-fluid w-100 px-md-3" }
const _hoisted_98 = { class: "form-group mb-4" }
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "typo__label default" }, [
  /*#__PURE__*/_createTextVNode("Conduite à Ténir (CAT) "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger font-weight-bold" }, "*")
], -1))
const _hoisted_100 = {
  key: 0,
  class: "red list-none"
}
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_102 = { class: "form-group mb-4 gray-color" }
const _hoisted_103 = {
  key: 0,
  class: "red list-none px-2"
}
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "typo__label default px-2" }, [
  /*#__PURE__*/_createTextVNode("Description diagnostic "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger font-weight-bold" }, "*")
], -1))
const _hoisted_106 = { class: "px-2 pb-2" }
const _hoisted_107 = {
  key: 0,
  class: "red list-none"
}
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_109 = { class: "form-group mb-4" }
const _hoisted_110 = { class: "w-100" }
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "exampleFormControlSelect1",
  class: "mb-1 typo__label"
}, [
  /*#__PURE__*/_createTextVNode("Date téléconsultation "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger font-weight-bold" }, "*")
], -1))
const _hoisted_112 = { class: "container-fluid" }
const _hoisted_113 = { class: "form-check mb-2" }
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "examenClinic_state"
}, " La consultation donnera-t-elle lieu à des examens clinique? ", -1))
const _hoisted_115 = {
  key: 0,
  class: "form-group mb-4 px-md-4 row"
}
const _hoisted_116 = { class: "col-md-6" }
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "typo__label default" }, "Examen clinique ", -1))
const _hoisted_118 = { class: "d-block d-md-flex align-items-center examen-item" }
const _hoisted_119 = { class: "col-md-6" }
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "typo__label default" }, "Description des examens cliniques", -1))
const _hoisted_121 = { class: "container-fluid" }
const _hoisted_122 = { class: "form-check mb-2" }
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "examen_state"
}, " La consultation donnera-t-elle lieu à des examens complémentaires? ", -1))
const _hoisted_124 = {
  key: 0,
  class: "form-group mb-4 px-md-4 col-md-6"
}
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "typo__label default" }, "Examen(s) complementaire(s)", -1))
const _hoisted_126 = { class: "d-block d-md-flex align-items-center examen-item" }
const _hoisted_127 = { class: "container-fluid" }
const _hoisted_128 = { class: "form-check mb-2" }
const _hoisted_129 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "OrdonanceState"
}, " Cette consultation aura t'elle une ordonnance ? ", -1))
const _hoisted_130 = {
  key: 0,
  class: "container-fluid px-md-3 row"
}
const _hoisted_131 = { class: "form-group mb-4 col-md-6" }
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "typo__label default" }, "Rédigez les informations d'ordonance ici", -1))
const _hoisted_133 = { class: "container-fluid" }
const _hoisted_134 = { class: "form-check mb-2" }
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "rendez-vous"
}, " Cette consultation aura t'elle un rendez-vous ? ", -1))
const _hoisted_136 = { class: "row" }
const _hoisted_137 = { class: "container-fluid px-md-3" }
const _hoisted_138 = { class: "form-group mb-4" }
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "typo__label default" }, [
  /*#__PURE__*/_createTextVNode("Motif Rendez-vous "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger font-weight-bold" }, "*")
], -1))
const _hoisted_140 = { class: "container-fluid w-100 px-0 px-md-3" }
const _hoisted_141 = { class: "form-group mb-4" }
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "exampleFormControlSelect1",
  class: "mb-1 typo__label"
}, [
  /*#__PURE__*/_createTextVNode("Date rendez-vous "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger font-weight-bold" }, "*")
], -1))
const _hoisted_143 = { class: "d-flex justify-content-md-center justify-content-between gap-1 mt-2" }
const _hoisted_144 = {
  key: 1,
  class: "position-absolute top-50 start-50"
}
const _hoisted_145 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "btn-spin"
}, null, -1))
const _hoisted_146 = [
  _hoisted_145
]

import VueMultiselect from "vue-multiselect";
import {
  ref,
  defineComponent,
  computed,
  reactive,
  onMounted,
  watchEffect,
  ComputedRef,
} from "vue";
import UserInfo from "@/components/organisms/UserInfo.vue";
import AddPrescription from "@/views/Admin/ePrescription/AddPrescription.vue";
import Icd from "@/components/organisms/Icd.vue";
import Editor from "@tinymce/tinymce-vue";
import Modal from "@/views/Admin/Teleconsultation/Modal.vue";
import AlertDetail from "@/views/Admin/alertes/AlertDetail.vue";
import AntecedentForm from "@/views/Admin/Teleconsultation/antecedents/AntecedentForm.vue";
import Tiny from "@/components/organisms/Tiny.vue";

import { useClipboard, usePermission } from "@vueuse/core";

import { useVuelidate } from "@vuelidate/core";
import { useTextareaAutosize } from "@vueuse/core";

import { required } from "@vuelidate/validators";
import moment from "moment";
import LoaderData from "@/components/molecules/LoaderData.vue";

import Datepicker from "@vuepic/vue-datepicker";

import AllergieService from "@/_services/AllergieService";
import { Allergie } from "@/_types/allergie";
//Allergie data

import { useStore } from "vuex";
import { useRoute } from "vue-router";
import router from "@/router";
import { Pagination } from "@/_types";
import { useToast } from "vue-toast-notification";
import VuexPersistence from "vuex-persist";


export default /*#__PURE__*/_defineComponent({
  __name: 'TeleconsultationForm',
  props: {
  id: Number,
},
  emits: ["gotoTeleconsultationForm"],
  setup(__props, { emit: __emit }) {

const route = useRoute();
const store = useStore();
const { text, isSupported, copy } = useClipboard();

const { textarea, input } = useTextareaAutosize();
//
const $toast = useToast();

const props = __props;

const examenClinic_state = ref(false);

const OrdonanceState = ref(false);

const consultationIntrouvable = ref(false);
const type_teleconsultation_ecrit = ref("");
const docState = ref("saved");
const dialogVisible = ref(false);
const antecedentVisible = ref(false);
const rules = {
  anamnese_id: { required },
  etablissement: { required },
  maladies: { required },
  motifs: { required }, 
  cat: { required },
  anamnese: { required },
  description_diagnostic: { required },
};

const AntecedentRules = computed(() => {
  return {
    description: { required },
    type: { required },
    date: { required },
  };
});
let AntecedentState = reactive({
  type: {},
  description: "",
  date: null,
});

const dataAntecedent: [] | any = ref([]);
const A$ = useVuelidate(AntecedentRules, AntecedentState);
const SaveAntecedent = () => {
  A$.value.$validate();
  if (!A$.value.$error) {
    let antecedent = {
      type: AntecedentState.type,
      description: AntecedentState.description,
      date: AntecedentState.date,
    };
    dataAntecedent.value.push(antecedent);
    localStorage.setItem("antecedent", JSON.stringify(dataAntecedent.value));
    antecedentVisible.value = false;
  } else {
    console.log(A$);
  }
};

const removeAntecedent = (e: any) => {
  dataAntecedent.value = dataAntecedent.value.filter(
    (item: any) => item.type !== e
  );
};

const checkOptions = ref(false);
const firstPage1 = ref(false);
const examen_state = ref(false);
const RDV = ref(false);
const checkForm = ref(true);
const formButton = ref(true);
const validateButton = ref(false);
const Form = () => (
  (checkOptions.value = false),
  (checkForm.value = true),
  (RDV.value = false),
  (formButton.value = true)
);
const checkMethod = () => (
  (firstPage1.value = true),
  (checkOptions.value = true),
  (checkForm.value = false),
  (RDV.value = false),
  (formButton.value = false)
);

const dataAllergie = computed(() => store.state.allergie.paginations);

const examenData = computed(() => store.state.examen.examen);

const examenCliniques = computed(
  () => store.state.examen_clinics.examen_clinic
);

const anamnese = computed(() => store.state.anamnese.anamnese);

const etablissements = computed(() => store.state.etablissement.etablissements);

const typesTeleconsultation: [] | any = computed(
  () => store.state.types.typesTeleconsultation
);
const typesAntecedent: [] | any = computed(
  () => store.state.types.typesAntecedent
);

const motifs = computed(() => store.state.motif.motifs);

const patient = computed(() => store.state.patient.select.user);

const urlModerator = computed(() => store.state.mettings.urlModerator);
const urlPatient = computed(() => store.state.mettings.urlPatient);

const alerte = computed(() => store.state.teleconsultations.alerte);
const patient_id = computed(() => store.state.patient.select.user?.id);
const dossier_medical_id = computed(
  () => store.state.patient.select.dossier?.id
);
const user_id = computed(() => store.state.users.user.id);

const AllergiePatient = computed(() => store.state.teleconsultations.allergies);
const antecedentPatient = computed(
  () => store.state.teleconsultations.antecedents
);

const mloadingStatus = computed(
  () => store.state.teleconsultations.mloadingStatus
);

const state: any = reactive({
    ordonnance_description: "",
  type_teleconsultation_ecrit: "",
  etablissement: "",
  motifs: [],
  motifs_secondaires: [],
  examens: [],
  examen_clinic: [],
  allergies: [],
  maladies: [],
  typesTc: "",
  cat: "",
  anamnese_id: "",
  motif: "",
  rendezVous: "",
  date: "",
  anamnese: "",
  description_diagnostic: "",
  description_examen_clinique: "",
  dateNow: new Date(),
  creator: user_id,
  patient_id: patient_id,
  dossier_medical_id: dossier_medical_id,
  isLoadingMotifPrincipale: false,
  isLoadingMotifSecondaire: false,
  isLoadingMotifAllergie: false,
  isLoadingExamenComplementaire: false,
  isLoadingEtablissement: false,
  isLoadingexamenClinic: false,
  isLoadingAnamneses: false,
});

const v$ = useVuelidate(rules, state);

const rdv = computed(() => {
  return store.state.teleconsultations.rendez_vous?.map((i: any) => {
    return {
      motifs: i.motifs,
      date: i.date,
    };
  });
});

const anamneseMap = function (anamnese: any) {
  return anamnese?.data.map((item: any) => {
    return {
      id: item.id,
      description: item.fr_description,
    };
  });
};

const DataAnamneseMap: any | [] = computed(() => anamneseMap(anamnese.value));

const etablissementMap = function (etablissements: any) {
  return etablissements?.data.map((item: any) => {
    return {
      id: item.id,
      name: item.name,
    };
  });
};

const dataEtablissementMap: [] | any = computed(() =>
  etablissementMap(etablissements.value)
);

const examensMap = function (examenData: any) {
  return examenData?.data.data.map((item: any) => {
    return {
      id: item.id,
      description: item.fr_description,
    };
  });
};

const dataExamenMap: [] | any = computed(() => examensMap(examenData.value));

const examenCliniqueMap = function (examenCliniques: any) {
  return examenCliniques?.data.data.map((item: any) => {
    return {
      id: item.id,
      description: item.fr_description,
    };
  });
};
const dataExamenClinicMap: [] | any = computed(() =>
  examenCliniqueMap(examenCliniques.value)
);

const allergieMap = function (dataAllergie: Allergie[] | any) {
  return dataAllergie?.data.map((item: Allergie) => {
    return { id: item.id, description: item.description };
  });
};

const dataAllergieMap: [] | any = computed(() => {
  if (dataAllergie.value) {
    return allergieMap(dataAllergie.value);
  }
  searchAlergie(); //
});

const asyncFindMotifPrincipale = (query: string) => {
  state.isLoadingMotifPrincipale = true;
  store.dispatch("motif/searchMotif", { search: query, page: 1 }).then(() => {
    state.isLoadingMotifPrincipale = false;
  });
};

const asyncFindMotifSecondaire = (query: string) => {
  state.isLoadingMotifSecondaire = true;
  store.dispatch("motif/searchMotif", { search: query, page: 1 }).then(() => {
    state.isLoadingMotifSecondaire = false;
  });
};

const asyncFindAllergie = (query: string) => {
  state.isLoadingMotifAllergie = true;
  store
    .dispatch("allergie/searchAllergies", { search: query, page: 1 })
    .then(() => {
      state.isLoadingMotifAllergie = false;
    });
};

const asyncFindExamenComplementaire = (query: string) => {
  state.isLoadingExamenComplementaire = true;
  store
    .dispatch("examen/searchExamens", { search: query, page: 1 })
    .then(() => {
      state.isLoadingExamenComplementaire = false;
    });
};

const asyncFindEtablissement = (query: string) => {
  state.isLoadingEtablissement = true;
  store
    .dispatch("etablissement/searchEtablissements", { search: query, page: 1 })
    .then(() => {
      state.isLoadingEtablissement = false;
    });
};

const asyncFindexamenClinic = (query: string) => {
  state.isLoadingexamenClinic = true;
  store
    .dispatch("examen_clinics/searchExamenClinics", { search: query, page: 1 })
    .then(() => {
      state.isLoadingexamenClinic = false;
    });
};

const asyncFindAnamneses = (query: string) => {
  state.isLoadingAnamneses = true;
  store
    .dispatch("anamnese/searchAnamnese", { search: query, page: 1 })
    .then(() => {
      state.isLoadingAnamneses = false;
    });
};

const MotifMap = function (dataMotif: any) {
  return dataMotif?.data.data.map((item: any) => {
    return {
      id: item.id,
      description: item.description,
    };
  });
};
const dataMotifMap: [] | any = computed(() => MotifMap(motifs.value));

const searchAlergie = async (value?: string) => {
  AllergieService.searchAllergie(value).then((res) => {
    let allergie: {} | null = [];
    if (res.data.data) {
      return (allergie = allergieMap(res.data.data));
    }
  });
};

const OpenMetting = () => {
  store.dispatch("mettings/createMetting", patient_id.value).then(() => {
    store.dispatch("mettings/joinMetting", patient_id.value).then(() => {
      setTimeout(() => {
        window.open(`${urlModerator.value}`, "_blank");
      }, 3000);
    });
  });
};

const OpenCall = (urlPatient: string) => {
  window.open(`${urlPatient}`, "_blank");
  localStorage.setItem("url", urlPatient);
};

const emit = __emit;
const linkCreate = ref(false);

if (route.query.slug) {
  linkCreate.value = true;
}

const createdMeeting = (id: 0) => {
  store.dispatch("mettings/createMetting", id).then(() => {
    window.open(`${store.state.mettings.urlModerator}`, "_blank");
    emit("gotoTeleconsultationForm");
  });
  store.dispatch("mettings/joinMetting", id);
};

const addMotif = (newTag: any) => {
  const tag = {
    id: null,
    description: newTag,
  };
  state.motifs.push(tag);
  motifs.value.data.data = [tag, ...motifs.value.data.data];
};

const CopyLink = (urlPatient = "") => {
  copy(urlPatient);
  $toast.success("Le lien de la vidéo conférence a été copier avec succès", {
    position: "bottom-right",
  });
};
const addMotifSecondaire = (newTag: any) => {
  const tag = {
    id: null,
    description: newTag,
  };
  state.motifs_secondaires.push(tag);
  motifs.value.data.data = [tag, ...motifs.value.data.data];
};
const addAllergie = (newTag: any) => {
  const tag = {
    id: null,
    description: newTag,
  };
  state.allergies.push(tag);
  dataAllergieMap.value = [tag, ...dataAllergieMap.value];
};

const addExamenComplementaire = (newTag: any) => {
  const tag = {
    id: null,
    description: newTag,
  };
  state.examens.push(tag);
  dataExamenMap.value = [tag, ...dataExamenMap.value];
};

const dateToFormat = (date: string) => moment(date).format("DD-MM-YYYY HH:mm");

onMounted(() => {
  //console.log("fullPath" ,route.fullPath)
  store.dispatch("allergie/fetchAllergiesAction");
  store.dispatch("etablissement/fetchEtablissements");
  store.dispatch("anamnese/fetchAnamnese");
  store.dispatch("examen/fetchExamen");
  store.dispatch("examen_clinics/getExamen_clinic");
  store.dispatch("motif/fetchMotifs");
  store.dispatch("types/fetchTypesTeleconsultation", "teleconsultations");
  store.dispatch("types/fetchTypesAntecedent", "antecedents");

  setTimeout(() => {
    store.dispatch("teleconsultations/fetchAlerte", {
      medecin_id: user_id.value,
      patient_id: patient_id.value,
    });
  }, 5000);
  store.dispatch("teleconsultations/fetchAllergies", patient_id.value);
  store.dispatch("teleconsultations/fetchAntecedents", patient_id.value);
  // store.dispatch("teleconsultations/getRendezVous")
});

const motifValidate = ref(false);
computed(() => {
  motifValidate.value = true;
  if (state.rendezVous && state.motif === "" && state.date === "") {
    return (motifValidate.value = false);
  } else if (state.rendezVous && state.motif != "" && state.date != "") {
    return (motifValidate.value = false);
  }
});

const createdTeleconsultation = (states: {}) => {
  console.log("states ", state);
    v$.value.$validate();

  console.log(" !v$.value.$error ",  !v$.value.$error);
  console.log(" state.motif  ",  state.motif );
  console.log("  state.rendezVous  ",   state.rendezVous );
  console.log(" state.date ",  state.date);
  console.log("==================",   !v$.value.$error &&
    state.rendezVous &&
    state.motif != "" &&
    state.date != "");
      console.log("==============eee====",   !v$.value.$error &&
    !state.rendezVous &&
    state.motif != "" &&
    state.date != "");
    
  if (
    !v$.value.$error &&
    state.rendezVous &&
    state.motif != "" &&
    state.date != ""
  ) {
    store.dispatch("teleconsultations/createdTeleconsultation", states);
  } else if (
    !v$.value.$error &&
    !state.rendezVous &&
    state.motif === "" &&
    state.date === ""
  ) {
    store.dispatch("teleconsultations/createdTeleconsultation", states);
  }
};

const describe = ref(false);

// computed(() => {
//     if (state.value == ""){
//         describe.value = true;
//     }
//     describe.value = false;
// })

const AnamneseDescribe = (value: string) => {
  state.anamnese_id = value;
  describe.value = false;
  if (state.anamnese_id !== "") describe.value = true;
};

return (_ctx: any,_cache: any) => {
  const _component_b_form_checkbox = _resolveComponent("b-form-checkbox")!
  const _component_b_popover = _resolveComponent("b-popover")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!typesTeleconsultation.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", {
            class: _normalizeClass(["form_tc d-md-flex w-100 default mb-3", [
              alerte.value ? 'justify-content-between' : ' justify-content-end',
            ]])
          }, [
            (alerte.value)
              ? (_openBlock(), _createElementBlock("h2", _hoisted_8, [
                  _hoisted_9,
                  _createTextVNode("Informations sur l'alerte ")
                ]))
              : _createCommentVNode("", true),
            (patient_id.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  (urlPatient.value)
                    ? (_openBlock(), _createElementBlock("li", {
                        key: 0,
                        class: "list-none cursor-pointer primary",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (CopyLink(urlPatient.value)))
                      }, _hoisted_13))
                    : _createCommentVNode("", true),
                  _createElementVNode("a", {
                    href: "#",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (OpenMetting())),
                    class: "circle-btn bg-primary btn b-video shadow text-white"
                  }, _hoisted_15)
                ]))
              : _createCommentVNode("", true)
          ], 2),
          (alerte.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("ul", _hoisted_17, [
                  _createElementVNode("li", _hoisted_18, [
                    _hoisted_19,
                    _createElementVNode("p", _hoisted_20, _toDisplayString(patient.value.nom) + " " + _toDisplayString(patient.value.prenom), 1)
                  ]),
                  _createElementVNode("li", _hoisted_21, [
                    _hoisted_22,
                    _createElementVNode("p", _hoisted_23, _toDisplayString(alerte.value.created_at), 1)
                  ]),
                  _createElementVNode("li", _hoisted_24, [
                    _hoisted_25,
                    _createElementVNode("p", {
                      class: _normalizeClass(["mb-1 status encours w-content", [
                    alerte.value.statut?.valeur == 'En cours'
                      ? 'encours'
                      : 'termine' || alerte.value.statut?.valeur == 'En attente'
                      ? 'enattente'
                      : 'termine',
                  ]])
                    }, _toDisplayString(alerte.value.statut?.valeur), 3)
                  ]),
                  _createElementVNode("li", _hoisted_26, [
                    _createElementVNode("button", {
                      class: "btn border border-default default",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (dialogVisible.value = true))
                    }, [
                      _hoisted_27,
                      _createTextVNode("Détails ")
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _hoisted_31,
                _createElementVNode("div", _hoisted_32, [
                  (typesTeleconsultation.value)
                    ? (_openBlock(), _createBlock(_unref(VueMultiselect), {
                        key: 0,
                        modelValue: state.typesTc,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((state.typesTc) = $event)),
                        multiple: false,
                        "close-on-select": true,
                        options: typesTeleconsultation.value,
                        "preserve-search": true,
                        placeholder: "Type Téléconsultation",
                        label: "libelle",
                        "track-by": "id"
                      }, null, 8, ["modelValue", "options"]))
                    : _createCommentVNode("", true)
                ]),
                (_unref(v$).$error && _unref(v$).typesTc.$invalid)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_33, [
                      _createTextVNode(_toDisplayString("veillez sélectionner un type") + " "),
                      _hoisted_34
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_35, [
                  _createVNode(_component_b_form_checkbox, {
                    id: "consultationIntrouvable",
                    modelValue: consultationIntrouvable.value,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((consultationIntrouvable).value = $event)),
                    class: "me-2",
                    name: "consultationIntrouvable"
                  }, null, 8, ["modelValue"]),
                  _hoisted_36
                ]),
                _createVNode(_Transition, { name: "fade" }, {
                  default: _withCtx(() => [
                    (consultationIntrouvable.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                          _withDirectives(_createElementVNode("input", {
                            id: "type_teleconsultation_ecrit",
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((state.type_teleconsultation_ecrit) = $event)),
                            class: "form-control",
                            placeholder: "Remplir le type de consultation"
                          }, null, 512), [
                            [_vModelText, state.type_teleconsultation_ecrit]
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_38, [
                _hoisted_39,
                _createElementVNode("div", _hoisted_40, [
                  (typesTeleconsultation.value)
                    ? (_openBlock(), _createBlock(_unref(VueMultiselect), {
                        key: 0,
                        modelValue: state.etablissement,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((state.etablissement) = $event)),
                        options: dataEtablissementMap.value,
                        "close-on-select": true,
                        "preserve-search": true,
                        placeholder: "Rechercher l'établissement de consultation",
                        label: "name",
                        "track-by": "id",
                        loading: state.isLoadingEtablissement,
                        onSearchChange: asyncFindEtablissement
                      }, null, 8, ["modelValue", "options", "loading"]))
                    : _createCommentVNode("", true)
                ]),
                (_unref(v$).$error && _unref(v$).etablissement.$invalid)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_41, [
                      _createTextVNode(_toDisplayString("L'établissement est obligatoire") + " "),
                      _hoisted_42
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_43, [
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("h2", _hoisted_46, [
                _hoisted_47,
                _createTextVNode("Téléconsultation de "),
                _createElementVNode("span", _hoisted_48, _toDisplayString(patient.value.nom), 1)
              ])
            ])
          ]),
          _createElementVNode("form", _hoisted_49, [
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("div", {
                class: _normalizeClass([[checkForm.value ? 'col' : 'col d-md-block d-none'], "px-0 px-md-2"])
              }, [
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("div", _hoisted_52, [
                    _hoisted_53,
                    _createElementVNode("div", _hoisted_54, [
                      (typesTeleconsultation.value)
                        ? (_openBlock(), _createBlock(_unref(VueMultiselect), {
                            key: 0,
                            modelValue: state.motifs,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((state.motifs) = $event)),
                            "tag-placeholder": "Ajouter un motif",
                            "close-on-select": true,
                            options: dataMotifMap.value,
                            "preserve-search": true,
                            placeholder: "Rechercher ou ajouter un motif",
                            label: "description",
                            "track-by": "id",
                            taggable: true,
                            onTag: addMotif,
                            loading: state.isLoadingMotifPrincipale,
                            onSearchChange: asyncFindMotifPrincipale
                          }, null, 8, ["modelValue", "options", "loading"]))
                        : _createCommentVNode("", true)
                    ]),
                    (_unref(v$).$error && _unref(v$).motifs.$invalid)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_55, [
                          _createTextVNode(_toDisplayString("Le motif principal est obligatoire") + " "),
                          _hoisted_56
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_57, [
                    _hoisted_58,
                    _createElementVNode("div", _hoisted_59, [
                      (typesTeleconsultation.value)
                        ? (_openBlock(), _createBlock(_unref(VueMultiselect), {
                            key: 0,
                            modelValue: state.motifs_secondaires,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((state.motifs_secondaires) = $event)),
                            "tag-placeholder": "Ajouter un motif",
                            multiple: true,
                            max: 2,
                            "close-on-select": true,
                            options: dataMotifMap.value,
                            "preserve-search": true,
                            placeholder: "Rechercher ou ajouter un motif",
                            label: "description",
                            "track-by": "id",
                            taggable: true,
                            onTag: addMotifSecondaire,
                            loading: state.isLoadingMotifSecondaire,
                            onSearchChange: asyncFindMotifSecondaire
                          }, null, 8, ["modelValue", "options", "loading"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_60, [
                    _hoisted_61,
                    (typesTeleconsultation.value)
                      ? (_openBlock(), _createBlock(_unref(VueMultiselect), {
                          key: 0,
                          modelValue: state.anamnese_id,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((state.anamnese_id) = $event)),
                          "close-on-select": true,
                          options: DataAnamneseMap.value,
                          "preserve-search": true,
                          onSelect: AnamneseDescribe,
                          placeholder: "Rechercher l'anamnèse",
                          label: "description",
                          "track-by": "id",
                          loading: state.isLoadingAnamneses,
                          onSearchChange: asyncFindAnamneses
                        }, null, 8, ["modelValue", "options", "loading"]))
                      : _createCommentVNode("", true),
                    (_unref(v$).$error && _unref(v$).anamnese_id.$invalid)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_62, [
                          _createTextVNode(_toDisplayString("L'anamnèse est obligatoire") + " "),
                          _hoisted_63
                        ]))
                      : _createCommentVNode("", true),
                    (describe.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                          _hoisted_65,
                          _createVNode(_unref(Editor), {
                            "api-key": "mm3cmjvl9px5ksezprcy72un7g456ii25fpje4frqemgkrqn",
                            init: {
                          height: 200,
                          menubar: false,
                          plugins: [
                            'advlist autolink lists link image charmap print preview anchor',
                            'searchreplace visualblocks code fullscreen',
                            'insertdatetime media table paste code help wordcount',
                          ],
                          toolbar:
                            'undo redo | formatselect | bold italic backcolor | \
                                                        alignleft aligncenter alignright alignjustify | \
                                                        bullist numlist outdent indent | removeformat | help',
                        },
                            modelValue: state.anamnese,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((state.anamnese) = $event))
                          }, null, 8, ["modelValue"]),
                          (_unref(v$).$error && _unref(v$).anamnese.$invalid)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_66, [
                                _createTextVNode(_toDisplayString("Entrez votre description") + " "),
                                _hoisted_67
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["form-group mb-4 px-4 py-2 rounded", [AllergiePatient.value ? 'gray-color' : '']])
                  }, [
                    _createElementVNode("div", _hoisted_68, [
                      (AllergiePatient.value?.length > 0)
                        ? (_openBlock(), _createElementBlock("label", _hoisted_69, "Allergies du patient"))
                        : (_openBlock(), _createElementBlock("label", _hoisted_70, "Pas d'allergies conçernant ce patient")),
                      _createElementVNode("ul", _hoisted_71, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(AllergiePatient.value, (allergieP, id) => {
                          return (_openBlock(), _createElementBlock("li", { key: id }, _toDisplayString(allergieP?.description), 1))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_72, [
                      (docState.value === 'annuler')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                            (typesTeleconsultation.value)
                              ? (_openBlock(), _createBlock(_unref(VueMultiselect), {
                                  key: 0,
                                  modelValue: state.allergies,
                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((state.allergies) = $event)),
                                  "tag-placeholder": "Ajouter une allergie",
                                  multiple: true,
                                  "close-on-select": true,
                                  options: dataAllergieMap.value,
                                  "preserve-search": true,
                                  placeholder: "Rechercher ou ajouter une allergie",
                                  label: "description",
                                  "track-by": "id",
                                  taggable: true,
                                  onTag: addAllergie,
                                  loading: state.isLoadingMotifAllergie,
                                  onSearchChange: asyncFindAllergie
                                }, null, 8, ["modelValue", "options", "loading"]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_74, [
                        _createVNode(_Transition, { name: "slide-up" }, {
                          default: _withCtx(() => [
                            (docState.value === 'saved')
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  type: "button",
                                  onClick: _cache[12] || (_cache[12] = ($event: any) => (docState.value = 'annuler')),
                                  class: "btn btn-dark d-flex align-items-center gap-1"
                                }, [
                                  _hoisted_75,
                                  _createTextVNode("Ajouter ")
                                ]))
                              : (docState.value === 'annuler')
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    type: "button",
                                    onClick: _cache[13] || (_cache[13] = ($event: any) => (
                              (docState.value = 'saved'), (state.allergies = '')
                            )),
                                    class: "btn shadow default d-flex align-items-center border border-dark justify-content-center gap-1"
                                  }, _hoisted_78))
                                : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(["form-group mb-4 px-4 py-2 rounded", [antecedentPatient.value ? 'gray-color' : '']])
                  }, [
                    (AllergiePatient.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                          _hoisted_80,
                          _createElementVNode("ul", _hoisted_81, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(antecedentPatient.value, (antecedentP, id) => {
                              return (_openBlock(), _createElementBlock("li", {
                                id: `popover-target-${antecedentP.uuid}`,
                                key: id
                              }, [
                                _createTextVNode(_toDisplayString(antecedentP.type?.libelle
                              ? antecedentP.type?.libelle
                              : antecedentP.type) + " ", 1),
                                _createVNode(_component_b_popover, {
                                  target: `popover-target-${antecedentP.uuid}`,
                                  triggers: "hover",
                                  placement: "top"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("p", {
                                      innerHTML: antecedentP?.description,
                                      class: "m-0"
                                    }, null, 8, _hoisted_83)
                                  ]),
                                  _: 2
                                }, 1032, ["target"])
                              ], 8, _hoisted_82))
                            }), 128)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataAntecedent.value, (item, id) => {
                              return (_openBlock(), _createElementBlock("li", {
                                id: `popover-target-${item.id}`,
                                key: id
                              }, [
                                _createTextVNode(_toDisplayString(item.type.libelle) + " ", 1),
                                _createElementVNode("i", {
                                  onClick: ($event: any) => (removeAntecedent(item.type)),
                                  class: "fa-solid fa-xmark cursor-pointer red"
                                }, null, 8, _hoisted_85),
                                _createVNode(_component_b_popover, {
                                  target: `popover-target-${item.id}`,
                                  triggers: "hover",
                                  placement: "top"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("p", {
                                      innerHTML: item?.description,
                                      class: "m-0"
                                    }, null, 8, _hoisted_86)
                                  ]),
                                  _: 2
                                }, 1032, ["target"])
                              ], 8, _hoisted_84))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", null, [
                      _createElementVNode("button", {
                        onClick: _cache[14] || (_cache[14] = ($event: any) => (antecedentVisible.value = true)),
                        type: "button",
                        class: "btn btn-dark"
                      }, [
                        _hoisted_87,
                        _createTextVNode("Ajouter ")
                      ])
                    ]),
                    _createVNode(Modal, {
                      modelValue: antecedentVisible.value,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((antecedentVisible).value = $event)),
                      title: "Nouveau antécédent",
                      bgcolor: "#172b4d",
                      colorTitle: "white",
                      notification: "true",
                      width: "md"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, [
                          (typesAntecedent.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                                _hoisted_89,
                                _createVNode(_unref(VueMultiselect), {
                                  modelValue: _unref(AntecedentState).type,
                                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(AntecedentState).type) = $event)),
                                  "deselect-label": "Can't remove this value",
                                  "track-by": "id",
                                  label: "libelle",
                                  placeholder: "Sélectionneer le type",
                                  options: typesAntecedent.value,
                                  searchable: false,
                                  "allow-empty": false
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("template", _hoisted_90, [
                                      _createElementVNode("strong", null, _toDisplayString(_ctx.option.type), 1)
                                    ])
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "options"]),
                                (_unref(A$).type.$error)
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_91, _toDisplayString("sélectionner un type d'antécédent")))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_92, [
                            _hoisted_93,
                            _createVNode(_unref(Datepicker), {
                              "auto-apply": "",
                              "close-on-auto-apply": false,
                              locale: "fr",
                              "max-date": new Date(),
                              "is-24": true,
                              modelValue: _unref(AntecedentState).date,
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(AntecedentState).date) = $event)),
                              placeholder: "sélectionner une date"
                            }, null, 8, ["max-date", "modelValue"]),
                            (_unref(A$).date.$error)
                              ? (_openBlock(), _createElementBlock("li", _hoisted_94, _toDisplayString("entrer une date")))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_95, [
                            _hoisted_96,
                            _createVNode(Tiny, {
                              height: 300,
                              state: _unref(AntecedentState),
                              v$: _unref(A$)
                            }, null, 8, ["state", "v$"])
                          ])
                        ]),
                        _createElementVNode("div", { class: "mt-3" }, [
                          _createElementVNode("button", {
                            onClick: SaveAntecedent,
                            type: "button",
                            class: "btn btn-primary"
                          }, " Enregistrer ")
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ], 2)
                ])
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass([[checkForm.value ? 'col' : 'col d-md-block d-none'], "px-0 px-md-2"])
              }, [
                _createElementVNode("div", _hoisted_97, [
                  _createElementVNode("div", _hoisted_98, [
                    _hoisted_99,
                    _createVNode(_unref(Editor), {
                      "api-key": "mm3cmjvl9px5ksezprcy72un7g456ii25fpje4frqemgkrqn",
                      init: {
                        height: 200,
                        menubar: false,
                        plugins: [
                          'advlist autolink lists link image charmap print preview anchor',
                          'searchreplace visualblocks code fullscreen',
                          'insertdatetime media table paste code help wordcount',
                        ],
                        toolbar:
                          'undo redo | formatselect | bold italic backcolor | \
                                                    alignleft aligncenter alignright alignjustify | \
                                                    bullist numlist outdent indent | removeformat | help',
                      },
                      modelValue: state.cat,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((state.cat) = $event))
                    }, null, 8, ["modelValue"]),
                    (_unref(v$).$error && _unref(v$).cat.$invalid)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_100, [
                          _createTextVNode(_toDisplayString("renseigner la conduite à ténir par le patient") + " "),
                          _hoisted_101
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_102, [
                    _createVNode(Icd, {
                      maladies: state.maladies
                    }, null, 8, ["maladies"]),
                    (_unref(v$).$error && _unref(v$).maladies.$invalid)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_103, [
                          _createTextVNode(_toDisplayString("Sélectionner au moins un diagnostic") + " "),
                          _hoisted_104
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_105,
                    _createElementVNode("div", _hoisted_106, [
                      _createVNode(_unref(Editor), {
                        "api-key": "mm3cmjvl9px5ksezprcy72un7g456ii25fpje4frqemgkrqn",
                        init: {
                          height: 200,
                          menubar: false,
                          plugins: [
                            'advlist autolink lists link image charmap print preview anchor',
                            'searchreplace visualblocks code fullscreen',
                            'insertdatetime media table paste code help wordcount',
                          ],
                          toolbar:
                            'undo redo | formatselect | bold italic backcolor | \
                                                        alignleft aligncenter alignright alignjustify | \
                                                        bullist numlist outdent indent | removeformat | help',
                        },
                        modelValue: state.description_diagnostic,
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((state.description_diagnostic) = $event))
                      }, null, 8, ["modelValue"]),
                      (_unref(v$).$error && _unref(v$).description_diagnostic.$invalid)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_107, [
                            _createTextVNode(_toDisplayString("renseigner la description du dignostic") + " "),
                            _hoisted_108
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_109, [
                    _createElementVNode("div", _hoisted_110, [
                      _hoisted_111,
                      _createVNode(_unref(Datepicker), {
                        "auto-apply": "",
                        "close-on-auto-apply": false,
                        locale: "fr",
                        "max-date": new Date(),
                        "is-24": true,
                        modelValue: state.dateNow,
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((state.dateNow) = $event))
                      }, null, 8, ["max-date", "modelValue"])
                    ])
                  ])
                ])
              ], 2)
            ]),
            _createElementVNode("div", _hoisted_112, [
              _createElementVNode("div", _hoisted_113, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((examenClinic_state).value = $event)),
                  class: "form-check-input",
                  type: "checkbox",
                  id: "examenClinic_state"
                }, null, 512), [
                  [_vModelCheckbox, examenClinic_state.value]
                ]),
                _hoisted_114
              ]),
              (examenClinic_state.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_115, [
                    _createElementVNode("div", _hoisted_116, [
                      _hoisted_117,
                      _createElementVNode("div", _hoisted_118, [
                        _createVNode(_unref(VueMultiselect), {
                          modelValue: state.examen_clinic,
                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((state.examen_clinic) = $event)),
                          options: dataExamenClinicMap.value,
                          multiple: true,
                          "preserve-search": true,
                          "close-on-select": true,
                          placeholder: "Rechercher un examen clinique",
                          label: "description",
                          "track-by": "id",
                          loading: state.isLoadingexamenClinic,
                          onSearchChange: asyncFindexamenClinic
                        }, null, 8, ["modelValue", "options", "loading"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_119, [
                      _hoisted_120,
                      _createVNode(_unref(Editor), {
                        "api-key": "mm3cmjvl9px5ksezprcy72un7g456ii25fpje4frqemgkrqn",
                        init: {
                      height: 200,
                      menubar: false,
                      plugins: [
                        'advlist autolink lists link image charmap print preview anchor',
                        'searchreplace visualblocks code fullscreen',
                        'insertdatetime media table paste code help wordcount',
                      ],
                      toolbar:
                        'undo redo | formatselect | bold italic backcolor | \
                                        alignleft aligncenter alignright alignjustify | \
                                        bullist numlist outdent indent | removeformat | help',
                    },
                        modelValue: state.description_examen_clinique,
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((state.description_examen_clinique) = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_121, [
              _createElementVNode("div", _hoisted_122, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((examen_state).value = $event)),
                  class: "form-check-input",
                  type: "checkbox",
                  id: "examen_state"
                }, null, 512), [
                  [_vModelCheckbox, examen_state.value]
                ]),
                _hoisted_123
              ]),
              (examen_state.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_124, [
                    _hoisted_125,
                    _createElementVNode("div", _hoisted_126, [
                      _createVNode(_unref(VueMultiselect), {
                        modelValue: state.examens,
                        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((state.examens) = $event)),
                        "tag-placeholder": "Ajouter un examen complémentaire",
                        multiple: true,
                        "close-on-select": true,
                        options: dataExamenMap.value,
                        "preserve-search": true,
                        placeholder: "Rechercher ou ajouter un examen complémentaire",
                        label: "description",
                        "track-by": "id",
                        taggable: true,
                        onTag: addExamenComplementaire,
                        loading: state.isLoadingExamenComplementaire,
                        onSearchChange: asyncFindExamenComplementaire
                      }, null, 8, ["modelValue", "options", "loading"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_127, [
              _createElementVNode("div", _hoisted_128, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((OrdonanceState).value = $event)),
                  class: "form-check-input",
                  type: "checkbox",
                  value: "",
                  id: "OrdonanceState"
                }, null, 512), [
                  [_vModelCheckbox, OrdonanceState.value]
                ]),
                _hoisted_129
              ]),
              (OrdonanceState.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_130, [
                    _createElementVNode("div", _hoisted_131, [
                      _hoisted_132,
                      _createElementVNode("div", null, [
                        _createVNode(_unref(Editor), {
                          "api-key": "mm3cmjvl9px5ksezprcy72un7g456ii25fpje4frqemgkrqn",
                          init: {
                        height: 300,
                        menubar: false,
                        plugins: [
                          'advlist autolink lists link image charmap print preview anchor',
                          'searchreplace visualblocks code fullscreen',
                          'insertdatetime media table paste code help wordcount',
                        ],
                        toolbar:
                          'undo redo | formatselect | bold italic backcolor | \
                                                alignleft aligncenter alignright alignjustify | \
                                                bullist numlist outdent indent | removeformat | help',
                      },
                          modelValue: state.ordonnance_description,
                          "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((state.ordonnance_description) = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_133, [
              _createElementVNode("div", _hoisted_134, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((state.rendezVous) = $event)),
                  class: "form-check-input",
                  type: "checkbox",
                  value: "",
                  id: "rendez-vous"
                }, null, 512), [
                  [_vModelCheckbox, state.rendezVous]
                ]),
                _hoisted_135
              ]),
              _createElementVNode("div", _hoisted_136, [
                _createElementVNode("div", {
                  class: _normalizeClass([[
                    state.rendezVous
                      ? 'col-md d-block d-md-block'
                      : 'col d-none',
                  ], "px-0 px-md-2"])
                }, [
                  _createElementVNode("div", _hoisted_137, [
                    _createElementVNode("div", _hoisted_138, [
                      _hoisted_139,
                      _createElementVNode("div", null, [
                        _createVNode(_unref(Editor), {
                          "api-key": "mm3cmjvl9px5ksezprcy72un7g456ii25fpje4frqemgkrqn",
                          init: {
                            height: 200,
                            menubar: false,
                            plugins: [
                              'advlist autolink lists link image charmap print preview anchor',
                              'searchreplace visualblocks code fullscreen',
                              'insertdatetime media table paste code help wordcount',
                            ],
                            toolbar:
                              'undo redo | formatselect | bold italic backcolor | \
                                                        alignleft aligncenter alignright alignjustify | \
                                                        bullist numlist outdent indent | removeformat | help',
                          },
                          modelValue: state.motif,
                          "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((state.motif) = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ])
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass([[
                    state.rendezVous
                      ? 'col-md d-block d-md-block px-md-3'
                      : 'col d-none',
                  ], "mt-3 mt-md-0"])
                }, [
                  _createElementVNode("div", _hoisted_140, [
                    _createElementVNode("div", _hoisted_141, [
                      _hoisted_142,
                      _createVNode(_unref(Datepicker), {
                        "auto-apply": "",
                        "close-on-auto-apply": false,
                        locale: "fr",
                        "min-date": new Date(),
                        "is-24": true,
                        modelValue: state.date,
                        "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((state.date) = $event))
                      }, null, 8, ["min-date", "modelValue"])
                    ])
                  ])
                ], 2)
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_143, [
                (!mloadingStatus.value)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: _cache[31] || (_cache[31] = _withModifiers(($event: any) => (createdTeleconsultation(state)), ["prevent"])),
                      type: "submit",
                      class: "btn btn-primary py-2 px-4 shadow"
                    }, " Enregistrer "))
                  : (_openBlock(), _createElementBlock("div", _hoisted_144, _hoisted_146))
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})